// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useMutation } from '@tanstack/react-query';
import { Choice, Party } from '@daml/types';
import { useLedgerApiClient } from '../../../contexts/LedgerApiContext';
import { LedgerExerciseArgs } from '../../../utils/LedgerApiClientV2';

export const useLedgerExercise = <T extends object, C, R, K>(choice: Choice<T, C, R, K>) => {
  const ledgerApi = useLedgerApiClient();
  return useMutation({
    mutationKey: ['ledgerExercise'],
    mutationFn: async (args: LedgerExerciseArgs<T, C>) => {
      let actAs: Party[] | undefined;
      let readAs: Party[] | undefined;

      if (args.submitter) {
        actAs = [args.submitter];
      } else {
        actAs = args.actAs;
        readAs = args.readAs;
      }

      return ledgerApi.exercise(choice, args.cid, args.argument, args.meta, actAs, readAs);
    },
  });
};
